import { GlobalResponseObject } from "@gtpl/shared-models/common-models";
import { ValueAdditionThreeDto } from "./addition-type-three.dto";

export class AllvalueAdditionThreeResponse extends GlobalResponseObject{

      data?: ValueAdditionThreeDto[];
    /**
     * 
     * @param status 
     * @param intlCode 
     * @param internalMessage 
     * @param data 
     */
    constructor(status:boolean, intlCode:number, internalMessage:string, data?: ValueAdditionThreeDto[]){
        super(status,intlCode,internalMessage);
        this.status = status;
        this.internalMessage = internalMessage;
        this.intlCode = intlCode;
        this.data = data;
    }

}